import { type FC } from 'react'
import { type StackProps } from '@chakra-ui/react'
import ContentContainer from 'ui/storefront/layout/ContentContainer'
import { Nav } from './Nav'
import {
  type SlideOutCategoriesDesktopContextState,
  SlideOutCategoriesDesktopProvider
} from './SlideOutCategoriesDesktopContext'

export interface ISlideOutProducts extends StackProps, SlideOutCategoriesDesktopContextState {}

export const MenuMultiColumnSlideOutCategoriesDesktop: FC<ISlideOutProducts> = ({
  customColors,
  paths,
  currentTopCategory,
  ...props
}) => {
  return (
    <SlideOutCategoriesDesktopProvider
      value={{
        customColors,
        paths,
        currentTopCategory
      }}
    >
      <ContentContainer
        className="slide-out-categories"
        minH="20vh"
        maxH="50vh"
        borderColor="primary"
        borderTopWidth="1px"
        p={0}
        pt={6}
        gap="6"
        w="100%"
        {...props}
      >
        <Nav />
      </ContentContainer>
    </SlideOutCategoriesDesktopProvider>
  )
}
